import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';
import { saveAs } from 'file-saver';

export const managementService = {
	findUser,
	deleteUser,
	updateUser,
	getReports,
	runReports,
	scheduledReports,
	saveReports
};

// #region assign

function findUser (criteria) {
	let addition = ''
	if (criteria.lastName) {
		addition += `&nameLast=${criteria.lastName}`
	}
	if (criteria.firstName) {
		addition += `&nameFirst=${criteria.firstName}`
	}
	if (criteria.staffId) {
		addition += `&staffId=${criteria.staffId}`
	}
	if (criteria.role) {
		addition += `&role=${criteria.role}`
	}
	if (criteria.status === true || criteria.status === false) {
		addition += `&active=${criteria.status}`
	}
	if (criteria.email) {
		addition += `&email=${criteria.email}`
	}
	return axios.get(utilityService.buildFullyQualifiedUrl(`account/find?studyCode=${criteria.study}` + addition),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function updateUser (criteria, userObj) {
	// If we have a valid study code then the user exists within the study already 
	// and can be updated via a PUT request. If the user does not have a study code 
	// then they DO NOT already exist and need to be added via a POST call.
	const isExistingUser = (userObj.studyCode)

	const endpointUrlToCall = utilityService.buildFullyQualifiedUrl(`account?studyCode=${criteria.study}`)

	if (isExistingUser) {
		return axios.put(endpointUrlToCall,
			userObj,
			// Third parameter is the configuration object
			{
				headers: utilityService.getHeaders()
			}
		)
	} else {
		return axios.post(endpointUrlToCall,
			userObj,
			// Third parameter is the configuration object
			{
				headers: utilityService.getHeaders()
			}
		)
	}
}

function deleteUser (criteria) {
	return axios.delete(utilityService.buildFullyQualifiedUrl(`account?studyCode=${criteria.study}&uuid=${criteria.staffUUID}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
} 

function getReports () {
	return axios.get(utilityService.getApiUrl(`analysis/report/reports`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function runReports (criteria) {
	var restOfCall = `studyCode=${criteria.studyCode}&reportClass=${criteria.reportClass}`
	if (criteria.interval) {restOfCall+=`&interval=${criteria.interval}`}
	if (criteria.sourceGPS) {restOfCall+=`&sourceGPS=${criteria.sourceGPS}`}
	if (criteria.responseFormat) {restOfCall+=`&responseFormat=${criteria.responseFormat}`}
	if (criteria.staffId) {restOfCall+=`&staffId=${criteria.staffId}`}
	if (criteria.timeStart) {restOfCall+=`&timeStart=${criteria.timeStart}`}
	if (criteria.timeEnd) {restOfCall+=`&timeEnd=${criteria.timeEnd}`}

	return axios.post(utilityService.getApiUrl(`analysis/report/run?` + restOfCall),
		null,
		{ headers: utilityService.getHeaders(), responseType: 'blob'}
	).then(response => {
		console.log(response.data);
		const headers = response.headers;
        const contentDispositionHeader = headers.get('content-disposition');

		let filename = 'eagle_reports.zip';
		if(contentDispositionHeader) {
			const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
			filename = result.replace(/"/g, '');
		}		        

		const blob = new Blob([response.data], { type: 'application/zip'});
		saveAs(blob, filename);
	})
	.catch(error => {
		console.error('Error downloading zip file:', error);
	});
}

function scheduledReports (criteria) {
	return axios.get(utilityService.getApiUrl(`analysis/report/reports?studyCode=${criteria.study}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function saveReports (criteria) {
	return axios.put(utilityService.getApiUrl(`analysis/report/reports?studyCode=${criteria.study}`),
		criteria.data,
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// #endregion assign
